<template lang="html">
  <button
    class="button"
    :class="{dark: darkmode, disabled}"
    :disabled=disabled
    @click="$emit('click', $event)"
  >
    <AveIcon v-if="icon" :icon="icon" :icon-type="iconType" :class="{dark: darkmode}" />
    {{label}}
  </button>
</template>

<script>
import AveIcon from '@/components/AveIcon.vue';

export default {
  components: {
    AveIcon,
  },
  props: {
    darkmode: Boolean,
    disabled: Boolean,
    icon: String,
    iconType: String,
    label: String,
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'

button
  width $inputWidth
  height $inputHeight
  background-color $white
  border $borderBoxes
  border-color $normal
  box-shadow $shadow
  border-radius $radiusBoxes
  outline none
  display flex
  align-items center
  flex-direction row
  padding-left $paddingInnerLeft
  margin auto
  margin-bottom $marginBottom
  &.dark
    background-color $normal
    border-color $darkmodeWhite
    box-shadow $darkmodeShadow
    color $darkmodeWhite
  &.disabled
    color $gray
    border-color $gray
    box-shadow none
    .icon
      color $gray

button:active
  box-shadow none

button:hover
  cursor: pointer;

.icon
  padding-right $paddingIconRight

</style>
